import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import type { RouteLocationAsRelative } from 'vue-router'
import type { ChatMessage, Conversation } from '../../../types/index.ts'

import { t } from '@nextcloud/l10n'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import NcActionButton from '@nextcloud/vue/components/NcActionButton'
import NcDateTime from '@nextcloud/vue/components/NcDateTime'
import NcListItem from '@nextcloud/vue/components/NcListItem'
import CloseCircleOutline from 'vue-material-design-icons/CloseCircleOutline.vue'
import AvatarWrapper from '../../AvatarWrapper/AvatarWrapper.vue'
import ConversationIcon from '../../ConversationIcon.vue'
import { CONVERSATION } from '../../../constants.ts'
import { EventBus } from '../../../services/EventBus.ts'
import { useDashboardStore } from '../../../stores/dashboard.ts'
import { formatDateTime } from '../../../utils/formattedTime.ts'
import { parseToSimpleMessage } from '../../../utils/textParse.ts'


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchMessageItem',
  props: {
    messageId: {},
    title: {},
    to: {},
    subline: {},
    actorId: {},
    actorType: {},
    token: {},
    timestamp: {},
    messageParameters: { default: () => ({}) },
    isReminder: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const router = useRouter()
const route = useRoute()
const store = useStore()
const dashboardStore = useDashboardStore()

const conversation = computed<Conversation | undefined>(() => store.getters.conversation(props.token))
const isOneToOneConversation = computed(() => conversation.value?.type === CONVERSATION.TYPE.ONE_TO_ONE)
const name = computed(() => {
	if (!props.isReminder || isOneToOneConversation.value) {
		return props.title
	}
	return t('spreed', '{actor} in {conversation}', { actor: props.title, conversation: conversation.value?.displayName ?? '' }, { escape: false, sanitize: false })
})
const richSubline = computed(() => {
	if (!props.isReminder) {
		return props.subline
	}

	return parseToSimpleMessage(props.subline, props.messageParameters)
})
const clearReminderLabel = computed(() => {
	if (!props.isReminder) {
		return ''
	}
	return t('spreed', 'Clear reminder – {timeLocale}', { timeLocale: formatDateTime(props.timestamp * 1000, 'shortWeekdayWithTime') })
})

const active = computed(() => {
	return route.fullPath === router.resolve(props.to).fullPath
})

/**
 * Focus selected message
 */
function handleResultClick() {
	if (route.hash === '#message_' + props.messageId) {
		// Already on this message route, just trigger highlight
		EventBus.emit('focus-message', { messageId: props.messageId })
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcListItem), {
    "data-nav-id": `message_${__props.messageId}`,
    name: name.value,
    to: __props.to,
    active: active.value,
    title: richSubline.value,
    "force-menu": "",
    onClick: handleResultClick
  }, _createSlots({
    icon: _withCtx(() => [
      (!__props.isReminder || isOneToOneConversation.value)
        ? (_openBlock(), _createBlock(AvatarWrapper, {
            key: 0,
            id: __props.actorId,
            name: __props.title,
            source: __props.actorType,
            "disable-menu": "",
            token: __props.token
          }, null, 8, ["id", "name", "source", "token"]))
        : (_openBlock(), _createBlock(ConversationIcon, {
            key: 1,
            item: conversation.value,
            "hide-user-status": ""
          }, null, 8, ["item"]))
    ]),
    subname: _withCtx(() => [
      _createTextVNode(_toDisplayString(richSubline.value), 1)
    ]),
    details: _withCtx(() => [
      _createVNode(_unref(NcDateTime), {
        timestamp: __props.timestamp * 1000,
        class: "search-results__date",
        "relative-time": "narrow",
        "ignore-seconds": ""
      }, null, 8, ["timestamp"])
    ]),
    _: 2
  }, [
    (__props.isReminder)
      ? {
          name: "actions",
          fn: _withCtx(() => [
            _createVNode(_unref(NcActionButton), {
              "close-after-click": "",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(dashboardStore).removeReminder(__props.token, __props.messageId)), ["stop"]))
            }, {
              icon: _withCtx(() => [
                _createVNode(CloseCircleOutline, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(clearReminderLabel.value), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["data-nav-id", "name", "to", "active", "title"]))
}
}

})